import loadable from "@loadable/component";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import usePostFormData from "../../customHooks/usePostFormData";
import { queryClient } from "../../root.component";

const CreateAuthorComponent = loadable(
  () => import("../../components/Author/CreateAuthor") as unknown as Promise<FC>
);

export const CreateAuthor = () => {
  const { mutateAsync, isPostLoading } = usePostFormData({
    queryKey: ["author-create"],
    navigateURL: "/blog/author",
  });

  const handleCreate = async (data: any, setError: any) => {
    const file = data.preview_image as File;
    delete data.preview_image;
    const url = APIS.BLOG_AUTHOR;
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      switch (typeof data[key]) {
        case "string":
        case "number":
        case "boolean":
          formData.append(key, data[key]);
          break;
        default:
          formData.append(key, JSON.stringify(data[key]));
      }
    });
    if (file instanceof File) formData.append("preview_image", file);
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status === 200) {
        queryClient.refetchQueries();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <CreateAuthorComponent
        //@ts-ignore
        handleCreate={handleCreate}
        isLoading={isPostLoading}
      />
    </>
  );
};
